module.exports = __webpack_public_path__ + "img/use-front.5a76ac41.png";